export default __webpack_public_path__ + "static/media/23_eye.a740af66.jpg";